<script lang="ts">
	import type { SectionType } from '@prisma/client';
	import SectionComponents from './SectionComponents.svelte';
	import { page } from '$app/stores';
	import type { FormConfig, SectionAll } from '$lib/config';
	import type Modal from '$lib/client/components/Modal.svelte';
	import Footer from '$lib/client/components/Footer.svelte';
	export let SectionType: SectionType;
	export let section: SectionAll;
	export let TotalSteps: number = 1;
	export let StepNumber: number = 0;
	export let LastSection: boolean = false;
	const formDef = $page.data as FormConfig;
</script>

<div class="row row-content" style="padding: 3px 10px">
	<div class="col d-flex justify-content-center">
		<div
			class="rounded-1 border form"
			style={!LastSection && SectionType == 'Stepper'
				? 'padding-bottom: 30px'
				: 'padding-bottom: 10px'}
		>
			<div class="row">
				{#if section?.Title}
					<div class="col">
						<h3>{section.Title}</h3>
					</div>
				{/if}
			</div>
			<SectionComponents bind:section />
			{#if LastSection}
				<Footer />
			{/if}
		</div>
	</div>
</div>
